'use strict';

import template from './template.html';


export default function(entityService) {
	'ngInject';

	return {
		scope: true,
		template: template,
		require: '^userListContainer',
		link: link,
	};

	function link(scope, element, attrs, ctrl) {
		scope.vm = ctrl;

		scope.addSelectedUser = function() {
			ctrl.addToList(scope.selectedUser);
			delete scope.selectedUser;
		}

	}
}
